export default {
  contracts: {
    activeContracts: 'สัญญาที่ใช้งานอยู่',
    productsAndHours: 'ผลิตภัณฑ์ที่ครอบคลุมและเวลาการสนับสนุนที่เหลือ',
    supported: 'ได้รับการสนับสนุน',
    notSupported: 'ไม่สนับสนุน',
    contact: 'ผู้จัดการ'
  },
  states: {
    OPEN: 'เปิด',
    AWAITING_REPLY: 'รอการตอบกลับ',
    CLOSED: 'ถูกปิดไปแล้ว',
    FEEDBACK_REQUIRED: 'โปรดแสดงความคิดเห็น',
    onlyRequired: 'แสดงเฉพาะรายการที่ต้องกระทำ',
    onlyWorkRequests: 'แสดงเฉพาะการอนุมัติคำขอทำงาน'
  },
  common: {
    New: 'สร้างใหม่',
    Open: 'เปิด',
    Pending: 'รอดำเนินการ',
    Closed: 'ถูกปิดไปแล้ว',
    create: 'สร้าง',
    cancel: 'ยกเลิก',
    goBack: 'ย้อนกลับ',
    close: 'ปิด',
    goToMain: 'กลับสู่หน้าหลัก'
  },
  property: {
    name: 'โรงแรม',
    allProperties: 'โรงแรมทั้งหมด',
    selectProperty: 'ระบุโรงแรม'
  },
  product: {
    name: 'ผลิตภัณฑ์',
    allProducts: 'ผลิตภัณฑ์ทั้งหมด',
    selectProduct: 'เลือกผลิตภัณฑ์',
    goBack: 'ย้อนกลับ',
    noProducts: 'ไม่พบผลิตภัณฑ์'
  },
  chart: {
    chooseMonth: 'ระบุเดือน',
    noData: 'ไม่มีข้อมูลสำหรับรอบระยะเวลาปัจจุบัน'
  },
  navigation: {
    main: 'หน้าหลัก',
    interactions: 'ใบสั่งงาน',
    contracts: 'สัญญา',
    signOut: 'ออกจากระบบ'
  },
  tickets: {
    createNewTitle: 'สร้างใบสั่งงาน',
    title: 'หัวข้อ',
    noTickets: 'ไม่พบใบสั่งงานจากข้อมูลที่ค้นหา',
    search: 'ค้นหา',
    createNew: 'สร้างใหม่',
    reopenOrDisagree: 'ไม่ยอมรับ',
    escalation: 'เลื่อนระดับ',
    reason: 'เหตุผล',
    reopen: 'ไม่ยอมรับ',
    escalate: 'เลื่อนระดับ',
    opinionTitle: 'ความคิดเห็นของคุณ สำคัญสำหรับเรา!',
    opinionBody: 'กรุณาให้คะแนนงานพนักงานฝ่ายสนับสนุนของเรา',
    time: 'ระยะเวลาการแก้ไขปัญหา',
    qualification: 'คุณสมบัติทางเทคนิค',
    communication: 'ความสามารถในการสื่อสาร',
    sendFeedback: 'ส่งความคิดเห็น',
    leaveFeedback: 'ฝากความคิดเห็น',
    close: 'ปิด',
    alreadyHasFeedback: 'ระบุความคิดเห็นในใบสั่งงานแล้ว',
    feedbackHasBeenSent: 'ความคิดเห็นถูกส่งเรียบร้อย',
    ticketHasBeenReopened: 'ใบสั่งงานถูกเปิดอีกครั้ง',
    ticketHasBeenEscalated: 'ใบสั่งงานได้รับการเลื่อนระดับ',
    comment: 'ความคิดเห็น',
    keyPlaceholder: 'พิมพ์ข้อความ',
    approve: 'อนุมัติ',
    reject: 'ปฏิเสธ',
    workRequestOnContractNotification:
      'เรียนคุณ {{fullName}}\n\nขณะนี้ คุณมีบริการเสริมมูลค่า {{hoursInSupportContract}} ชั่วโมงรวมอยู่ในสัญญาการสนับสนุนของคุณ\nตั๋ว {{workRequestId}} ต้องใช้เวลา {{hoursRequested}} ชั่วโมงจึงจะเสร็จสมบูรณ์ \n\nโปรดอนุมัติการหักชั่วโมงจากยอดคงเหลือสำหรับงานข้างต้น\nขอบคุณ\n\nขอแสดงความนับถือ\n{{ผู้เขียน}}',
    workRequestChargeableNotification:
      'เรียน คุณ {{fullName}}\n\nงานนี้ไม่รวมอยู่ในบริการหรือการรับประกันภายใต้สัญญา เรายินดีที่จะกำหนดเวลาและช่วยเหลือ เราใช้เวลาประมาณ {{hoursRequested}} ชั่วโมงในการดำเนินการตามคำขอ {{workRequestId}} ให้เสร็จสิ้น\n\nค่าใช้จ่ายในการดำเนินการตามคำขอนี้จะเท่ากับ {{amount}}\nข้อเสนอนี้ใช้ได้ภายใน 7 วันนับจากวันที่ออก \nหากเวลาจริงที่ใช้เกินกว่าใบเสนอราคาเดิม แบบฟอร์มคำขอเพิ่มเติมสำหรับชั่วโมงเพิ่มเติมจะถูกส่งไปยังผู้ร้องขอเพื่อขออนุมัติ หากเวลาโดยประมาณน้อยกว่าใบเสนอราคาเดิม ใบเสนอราคาเดิมจะถูกยกเลิก และใบเสนอราคาที่แก้ไขจะ ถูกส่งไปแล้ว\n\nโปรดอนุมัติงานเพิ่มเติมและเรียกเก็บเงิน\n\nขอแสดงความนับถือ\n{{ผู้เขียน}}',
    workRequestCommentRequired: 'โปรดระบุเหตุผลในการปฏิเสธคำของาน'
  },
  severity: {
    name: 'ระดับความรุนแรง',
    0: 'ปกติ',
    1: 'สูง',
    2: 'ร้ายแรง'
  },
  forms: {
    password: 'รหัสผ่าน',
    confirmPassword: 'ยืนยันรหัสผ่าน',
    passwordsDoNotMatch: 'รหัสผ่านไม่ตรงกัน',
    updatePassword: 'ปรับปรุงรหัสผ่าน',
    askRestore: 'ถามสำหรับปรับปรุงรหัสผ่าน',
    remember: 'จดจำฉัน',
    restorePassword: 'กู้คืนรหัสผ่าน',
    signIn: 'เข้าสู่ระบบ'
  },
  transactions: {
    date: 'วันที่',
    type: 'ประเภท',
    comment: 'ความคิดเห็น',
    status: 'สถานะ',
    subject: 'หัวข้อคำร้อง',
    name: 'รายการ',
    hours: 'ชั่วโมง',
    viewTransactions: 'ดูรายการ',
    types: {
      WORK_REQUEST: 'คำร้อง',
      CONTRACT_ACTIVATION: 'การเปิดใช้งานสัญญา',
      CONTRACT_EXPIRATION: 'หมดอายุสัญญา',
      MANUAL_ADJUST_ADD: 'ปรับเปลี่ยน - เพิ่ม',
      MANUAL_ADJUST_DEDUCT: 'ปรับเปลี่ยน - ลด',
      TRANSFER_PROPERTY: 'การโอนเปลี่ยนโรงแรม',
      TRANSFER_PRODUCT: 'การเปลี่ยนผลิตภัณฑ์'
    }
  },
  transactionDetail: {
    name: 'รายละเอียดรายการ',
    num: 'ตัวเลข',
    insertTime: 'วันที่สร้าง',
    requestorName: 'ผู้ร้องขอ',
    subject: 'หัวเรื่อง',
    status: 'สถานะ',
    acceptTime: 'วันที่ตกลง',
    cancelTime: 'วันที่ยกเลิก',
    hours: 'ชั่วโมง',
    hourType: 'ประเภทชั่วโมง',
    workText: 'รายละเอียดงาน',
    plannedDate: 'วันที่คาดการณ์'
  },
  statuses: {
    Approved: 'อนุมัติ',
    Pending: 'รอดำเนินการ',
    Cancelled: 'ถูกยกเลิก'
  },
  hoursTypes: {
    'Included in contract': 'รวมอยู่ในสัญญา',
    'Installation hours': 'จำนวนชั่วโมงการติดตั้ง',
    'Preventative visit': 'ป้องกันการเยี่ยมชม',
    Chargeable: 'สามารถเรียกเก็บเงินได้'
  },
  errors: {
    unknown: 'ข้อผิดผิดพลาด',
    1000: 'คำร้องขอ ผิดพลาด',
    1001: 'คำร้องขอ ผิดพลาด',
    1: 'ชื่อผู้เข้าใช้หรือรหัสผ่านไม่ถูกต้อง',
    2: 'เซสชันหมดอายุ',
    3: 'ไม่พบโรงแรมที่ระบุ',
    4: 'ไม่พบผลิตภัณฑ์ที่ระบุ',
    7: 'ไม่พบการตอบสนอง',
    8: 'คำร้องถูกปิดไปแล้ว',
    11: 'การละเมิดการเข้าถึง',
    12: 'ไม่พบคำร้องที่ระบุ'
  }
}
